exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#terms_Conditions iframe{min-width:200px;width:100%;min-height:450px;max-height:450px;border:1px solid gray}", "", {"version":3,"sources":["C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/terms/C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/terms/terms.component.scss"],"names":[],"mappings":"AAAA,yBAEQ,gBAAgB,WACL,iBACM,iBACA,qBACK,CACzB","file":"terms.component.scss","sourcesContent":["#terms_Conditions{\r\n    iframe{\r\n        min-width: 200px; \r\n        width: 100%;\r\n        min-height: 450px;\r\n        max-height: 450px;\r\n        border: 1px solid gray;\r\n    }\r\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/terms/terms.component.scss
// module id = PRGL
// module chunks = 7